/*global Show*/
import {device} from './Helpers/UserDevice';
import {$ , scrollToPos,set_css_variables,locale} from './Helpers/utils';
import EsroHelper from './Helpers/EsroHelper';
import moment from "moment";
import 'moment/locale/he';

export const SHOW_TEMPLATE = 'template_show';
export const VIEW_SELECT_SHOW = 'selectShow';
export const VIEW_SELECT_SHOW_INSIDE_CAT = `${VIEW_SELECT_SHOW}_inView`;
export const VIEW_START = 'start';
export const VIEW_IFRAME = 'iframe';




class TicketSelector{
    constructor(props){
        this._data = Object.assign({}, props || {});
    }

}


const disable_order = !!site.disable_order;
const disable_order_title = disable_order && site.disable_order_title;
const disable_order_message = disable_order && site.disable_order_message;


const isShow = typeof Show !== 'undefined';

if(isShow){

    Show = Object.assign(Show, {
        loader         : null,
        iframeSrc      : 'https://www.kupat.co.il/',
        stage          : 'start',
        template       : null,
        hasOneShow     : false,
        thankuOpend    : false,
        hasReOpenIframe: false,
    });


    new TicketSelector(Show)

}







    (function() {

        if(!isShow){
            return
        }

        var $ = jQuery;


    Show.loadPage = function() {
        $('#loading').removeClass('firstLoad');
        if($('#mainContentarea').hasClass('hasoneshow')) {
            Show.hasOneShow = true;
        }

    };
    Show.openContent = function(index) {
        var item = Show.menu[index];
        var layout = item.content[0].acf_fc_layout;

        switch(layout) {
            case 'content_area':
                var contentHtml = '<div class="inner"><div class="aboutTxt">';
                contentHtml += item.content[0].content_area_html;
                contentHtml += '</div></div>';
                $.fancybox.open({
                    type      : 'html',
                    content   : contentHtml,
                    scrolling : 'auto',
                    topRatio  : 0,
                    padding   : 0,
                    margin    : [42, 10, 10, 10],
                    beforeShow: function() {
                    }
                });
                break;
            case 'gallery_area':

                var content = item.content[0].gallery_area_images;
                for(var i in content) {
                    content[i].href = content[i].url;
                }
                $.fancybox(content, {
                    scrolling    : 'no', padding: 0, maxWidth: 700, maxHeight: '80%', beforeLoad: function() {
                    }, beforeShow: function() {
                    }, title     : ""
                });
                break;
            case 'video_area':
                var href = item.content[0].video_area_vid + '?autoplay=1&rel=0&amp;controls=0&amp;showinfo=0&enablejsapi=1&wmode=transparent&loop=1';
                $.fancybox.open({
                    scrolling    : 'no', padding: 0, maxWidth: 700, maxHeight: '80%', beforeShow: function() {
                        if(jQuery('#vid_control').length) {
                            jQuery('#vid_control .pause').trigger('click');
                        }
                    }, afterClose: function() {
                        if(jQuery('#vid_control').length) {
                            jQuery('#vid_control .play ').trigger('click');
                        }
                    }, title     : "", 'type': 'iframe', href: href

                });

                break;
            case 'cast_area':
                var castboxes = [];
                item.content[0].actor.forEach(function(e) {
                    castboxes.push(Show.castMember(e));
                });

                $.fancybox(castboxes, {
                    scrolling : 'auto',
                    'type'    : 'html',
                    maxWidth  : 700,
                    padding   : 5,
                    maxHeight : '80%',
                    beforeLoad: function() {
                    },
                    beforeShow: function() {
                    }
                });
                break;
        }

    };
    Show.castMember = function(actor) {
        var wrap = $('<div>');
        var item = $('<article>', {
            'class': 'castbox', 'data-thumbnail': actor.img
        });
        var img = $('<img>', {
            src: actor.img, alt: actor.name
        });
        var details = $('<div class="details">');
        var clear = $('<div class="clearfix">');
        var name = $('<h2 class="name">').html(actor.name);
        var char = $('<h3 class="char">').html(actor.role);
        var desc = $('<div class="desc">').html(actor.txt);

        details.append(name, char, desc);
        item.append(img, details, clear);
        wrap.append(item);

        return wrap.html();
    };
    Show.showPop = function(pop, stage, classtoadd) {



        var contentHtml = '<div class="inner"><div data-show="' + stage + '">';
        contentHtml += $(pop).html();
        contentHtml += '</div></div>';
        $.fancybox.open({
            type      : 'html',
            content   : contentHtml,
            scrolling : 'auto',
            topRatio  : 0,
            padding   : 0,
            margin    : [42, 10, 10, 10],
            beforeShow: function() {
                if(typeof(classtoadd) !== "undefined") {
                    $('.fancybox-wrap').addClass(classtoadd);
                }
            }
        });

        $(document).on('click', '#Ok', function(e) {
            e.preventDefault();
            $.fancybox.close();
            var stage = $(this).parents('.prepop').data('show');
            Show.showStage(stage);
        });
    };
    Show.showStage = function(stage) {
        Show.stage = stage;
        $('.show-page').attr('data-stage', stage);

        const ticketsBack = $('.tickets-back');
        switch(stage) {
            case VIEW_START:
                $('#actions').fadeIn();
                $('#bottom_actions').fadeIn();
                $('#showsPanel').hide();
                $('#overlay').hide();
                $('#frame').removeClass('active');
                $('#frame').hide();
                $('.tab-sub-title').show();
                ticketsBack.hide();
                break;
            case VIEW_SELECT_SHOW:
                $('#overlay').hide();
                $('#showsPanel').fadeIn();
                $('#frame').removeClass('active');
                $('#frame').hide();
                $('#bottom_actions').hide();
                Show.displayFixes();
                $('.tab-sub-title').show();
                if(Show.template == 'template_videoBg') {
                    $('#actions').hide();
                }
                //clear calander
                if(Show.datesView === "buttons_by_calendar") {
                    Show.handleCalendarReset();
                }


                break;
            case VIEW_SELECT_SHOW_INSIDE_CAT:
              //  ticketsBack.toggle(device.mobile);
                break;
            case VIEW_IFRAME:
                $('.tab-sub-title').hide();

                if(Show.template == 'template_videoBg') {
                    //$('#showsPanel').hide();
                    // $('#overlay').fadeIn();
                    $('#frame').addClass('active');
                    $('#frame').fadeIn();
                    Show.displayFixes('iframe');
                }
                else {
                    $('#showsPanel').hide();
                    $('#frame').addClass('active');
                    $('#frame').fadeIn();

                }

                break;
        }
    };
    Show.loader = function(active) {
        $('#loading').toggle(active);
        if(active) {
            setTimeout(function() {
                Show.loader(false);
            }, 4000);
        }
    };
    Show.ui = function() {
        Show.allRows     = $('ul.buttons_cats>li');
        Show.allUls      = $('ul.buttons_cats>ul');
        Show.selectedRow = null;
        Show.iframeisPopup = $('#frame').hasClass('show_pop');

        const heighLabel ='זמינות גבוהה';
        const midLabel ='זמינות בינונית';
        const lowLabel ='זמינות נמוכה';
        const charsLabel = 'כסאות בודדים';
        const newLabel   = 'מופע חדש';
        const classMap = {
             [heighLabel] : 'heighLabel',
             [midLabel] : 'midLabel',
             [lowLabel]   : 'lowLabel',
             [charsLabel]: 'charsLabel',
             [newLabel]: 'newLabel',
        };
        try {
            Object.keys(classMap).forEach((txt)=>{
                const found =  $(`.ticket-row-inner .free_text:contains(${txt})`);
                found.addClass(classMap[txt]);
            });

        } catch(e) {    }

        $(document).on('click', '.tickets-back', function(e) {
            if(device.mobile && Show.stage === VIEW_SELECT_SHOW){
                Show.hideTicketsTab();
                return;
            }
                backToSelectShow();
        });

        function backToSelectShow(){
            Show.currentCat = '';
            Show.allRows.removeClass('active');
            Show.allUls.slideUp('fast');

            if(Show.hideOthers){
                Show.allRows.not(Show.selectedRow).fadeIn('fast');
            }
            Show.selectedRow = null;
            var insideDaysView = ($('#selectShows').hasClass('inView'));
            if(insideDaysView) {
                Show.showStage(VIEW_SELECT_SHOW);

                $('#selectShows').removeClass('inView');
                $('ul.cat-shows').fadeOut('fast');
                Show.allRows.removeClass('hide active');
                if(Show.datesView !== "buttons_by_calendar") {
                    Show.allRows.fadeIn('fast');
                }
                if(Show.datesView === "buttons_by_city_calendar" || Show.datesView === "buttons_by_freeText_calendar") {
                    Show.calanderWrap.hide();
                    $('.iscalanderCityhide').removeClass('iscalanderCityhide');
                    Show.calanderWrap.parent().removeClass('is-active');
                    Show.calanderWrap.find('.inner-map-title h4').html("");
                    Show.selectedDate = null;

                }
                Show.currentCat = '';
            }
            else {
                if(Show.stage === VIEW_START) {
                    top.location = site.siteUrl;
                    return;
                }

                Show.showStage(VIEW_START);
            }
        }

        $(document).on('click', '#frame .backBtn', function(e) {
            var show = $(this).data('show');
            Show.iframePage = false;
            Show.showStage(show);
        });


        $(document).on('click', '#order', function(e) {

            if($(this).hasClass('contact')){
                e.preventDefault();
                Show.activateContactTab();
                return;
            }
            if(disable_order){
                e.preventDefault();
                site.sInfo(disable_order_title, disable_order_message);
                return;
            }

            if($(this).hasClass('external')) {
                return true;
            }
            e.preventDefault();
            Show.activateTicketsTab();

            if(!$(this).hasClass('order_show')) {
                Show.showStage(VIEW_SELECT_SHOW);
            }
        });
        $(document).on('click', '.order_show', function(e) {
            var that = $(this)

            if(disable_order){
                e.preventDefault();
                site.sInfo(disable_order_title, disable_order_message);
                return;
            }

            var popText = that.attr('data-pop');
            if(popText) {
                e.preventDefault();
                Show.openTicketPopText(popText);
                return;
            }

            const parent = that.parents('li');
            if($(this).hasClass('soldout') || parent.hasClass('soldout')) {
                e.preventDefault();
                return;
            }

            if(parent.hasClass('external')) {
                return;
            }

            e.preventDefault();
            if(that.hasClass('has_timer') || (that.hasClass('visited') && that.attr('id') === 'order')) {
                return;
            }


            Show.openTermsPop().then(function() {

                Show.updateLastOpend(that);
                var insideDaysView = ($('#selectShows').hasClass('inView'));
                if(insideDaysView) {
                    $('#selectShows .backBtn').click();
                }
                var popText = that.attr('data-pop');
                if(popText) {
                     Show.openTicketPopText(popText);
                }

                if(Show.hasOneShow) {
                    var to = jQuery('#frame').offset().top - 40;
                    scrollToPos(to);
                    return;
                }
                that.addClass('visited')

            }, function() {   });




        });


        $(document).on('click', '.thumbsGal a', function(e) {
            e.preventDefault();
            var index = $('.gallerySection').data('index');
            var selected = $('.thumbsGal:visible a').index($(this));
            if(site.isfancyOpen()) {
                $.fancybox.close();
                setTimeout(function() {
                    Show.openGalleryImage(index, selected);
                }, 350);
                return;
            }
            Show.openGalleryImage(index, selected);

        });
        $(document).on('click', '.thumbsClips a', function(e) {
            e.preventDefault();
            var href = $(this).attr('href');
            $.fancybox.open({
                scrolling    : 'no', padding: 0, maxWidth: 700, maxHeight: '80%', beforeShow: function() {
                    if($('#vid_control').length) {
                        $('#vid_control .pause:visible').trigger('click');
                    }
                }, afterClose: function() {
                    if($('#vid_control').length) {
                        $('#vid_control .play:visible ').trigger('click');
                    }
                }, title     : "", 'type': 'iframe', href: href
            });

        });


        $(document).on('click', '#topshowmenu a,#show-menu a', function(e) {
            //todo
            var type = $(this).data('type');
            var index = $(this).data('index');
            var href = $(this).attr('href');
            var hasPassword = $(this).attr('data-password');
            if(type == 'external_url') {
                if(hasPassword) {
                    e.preventDefault();
                    site.openPasswordPop(index);
                }
                return true;
            }
            e.preventDefault();
            if(type == 'content_area') {

                if(Show.template == 'template_videoBg') {
                    Show.showPop(href, 'start');
                }
                else {
                    var to = $(href).offset().top - 80;
                    scrollToPos(to, function() {
                        $(href).focus();
                    });
                }

            }
            else if(type == 'gallery_area' && $(this).data('gal') == 'thumbsGal' || type == 'video_gallery') {
                if(Show.template == 'template_videoBg') {
                    Show.showPop(href, 'start', 'thumbs');
                }
                else {
                    var to = $(href).offset().top - 80;
                    scrollToPos(to, function() {
                        $(href).focus();
                    });
                }

            }
            else {
                Show.openContent(index);
            }

        });
        $(document).on('click', '.closeframe', function(e) {
            e.preventDefault();
            var show = $(this).data('show');
            if(Show.template == "template_empty") {
                show = 'selectShow';
            }
            Show.showStage(show);
        });
        $(document).on('click', '#show-navbar #mainNavBtn', function(e) {
            e.preventDefault();
            $('.navbar-collapse').slideToggle();
            $(this).toggleClass('on');

        });

        $(document).on('click', 'ul.buttons_cats>li a', function(e) {

            if($(this).hasClass('order_show')) {
                return;
            }
            if($(this).hasClass('external')) {
                return;
            }
            if($(this).hasClass('has_timer')) {
                return false;
            }


            e.preventDefault();


            const iscalanderCity = Show.datesView === "buttons_by_city_calendar";
            const iscalanderFreeText = Show.datesView === "buttons_by_freeText_calendar";
            const button = $(this);
            Show.selectedRow = button.parents('li');
            const catStr = button.data('cat');
            const ul = $(`ul.cat-shows[data-cat='${catStr}']`);
            if(Show.selectedRow.hasClass('active')){
                backToSelectShow();
                return
            }

            Show.allRows.removeClass('active');
            Show.allUls.slideUp('fast');

            Show.currentCat = catStr;

            try {
                const shows = Show.getRelevantShows();
                if(shows.length === 1 && !Show.always_open_group) {
                    self.location.href = shows[0].url;
                    return;
                }
                } catch(e) {   }




            Show.showStage(VIEW_SELECT_SHOW_INSIDE_CAT);
            ul.slideDown('fast');
            Show.selectedRow.addClass('active');
            $('#selectShows').addClass('inView');

           if(Show.hideOthers){
               Show.allRows.not(Show.selectedRow).hide();
           }


            if(iscalanderCity || iscalanderFreeText) {
                var calanderWrap = $('#calanderWrap');
                var calander = $('#calendar');

                var firstDate = $(`ul.cat-shows[data-cat='${Show.currentCat}'] li`).first().attr('data-date');
                firstDate = moment(firstDate, 'DD/MM/YYYY').toDate();
                var calendar_target = Show.selectedRow.next();
                calander.datepicker("setDate", firstDate);
                $(`ul.cat-shows[data-cat='${catStr}'] li`).addClass('iscalanderCityhide');
                calendar_target.append(calanderWrap);
                calanderWrap.fadeIn('fast');

            }


        });


    };

    Show.openTicketPopText = function(popText) {
        var contentHtml = '<div class="inner"><div class="alert">' + popText + '</div></div>';
        $.fancybox.open({
            type     : 'html',
            content  : contentHtml,
            scrolling: 'auto',
            topRatio : 0,
            padding  : 0,
            margin   : [42, 10, 10, 10],
            helpers  : {
                overlay: {
                    locked: false
                }
            }
        });
    }

    Show.openGalleryImage = function(index, selected) {
        var item = Show.menu[index];
        var content = item.content[0].gallery_area_images;
        for(var i in content) {
            content[i].href = content[i].url;
        }
        $.fancybox(content, {
            scrolling    : 'no', padding: 0, index: selected, maxWidth: 700, maxHeight: '80%', beforeLoad: function() {
            }, beforeShow: function() {
            }, title     : "", helpers: {
                overlay: {
                    locked: false
                }
            }
        });

    };
    Show.updateSession = function(cb) {
        $.ajax({
            type: "POST", data: Show.lastOpen, url: site.ajaxUrl + "?action=updateShowSession", success: function(r) {
                console.log(r);
                if(typeof(cb) == 'function') {
                    cb();
                }
            }
        });


    };
    Show.updateLastOpend = function(elem) {
        Show.lastOpen = {
            date  : elem.find('.date').text(),
            city  : elem.find('.city').text(),
            hall  : elem.find('.hall').text(),
            starts: elem.find('.starts').text(),
            url   : elem.attr('url')
        };

    };
    Show.esro = function() {
        if(typeof($esro) === 'undefined') {
            return;
        }
        return new EsroHelper($esro);
    };
    Show.removePassDates = function() {
        $('#days li a').each(function() {
            var adate = $(this).data('date').split('-');
            var date = new Date('2016', adate[1] - 1, adate[0]);
            var today = new Date();
            today.setHours(0, 0, 0, 0);

            if(today > date) {
                $(this).parent().remove();
            }
        });
    };
    Show.displayFixes = function(stage) {
        var showFooterHeight = $('#showFooter').height();
        var siteHeader = $('#siteHeader').height();
        var winHeight = $(window).height();
        var footerHeight = $('#pageFooter').height();
        var topshowmenuHeight = $('#topshowmenu').length ? $('#topshowmenu').height() : 0;


       /* $('#main').css('min-height', winHeight - showFooterHeight - siteHeader - footerHeight - topshowmenuHeight);
        if(stage == 'iframe') {
            $('#main').css('min-height', winHeight - showFooterHeight - siteHeader - topshowmenuHeight);
        }
*/

        if(!device.mobile && Show.template === SHOW_TEMPLATE) {
            fixOrderBtnPosition();
        }

        function fixOrderBtnPosition() {
            var ref = jQuery('.data_table');
            var btn = jQuery('#actions');
            btn.css('padding-top', ref.height() / 2 - btn.height() / 2);
        }

        if(device.mobile && $('#topshowmenu:visible').length > 0) {
            $('#mainNavBtn').click();
        }

    };



    Show.handleCalendarReset = function() {
        $('#calendar').show();
        $('.calendar-info').show();
        $('.buttons_cats').hide();
    };

    Show.initCalendar = function() {
        var hascalender = false;
        var calenderbyCity = Show.datesView === "buttons_by_city_calendar";
        var calenderbyFreeText = Show.datesView === "buttons_by_freeText_calendar";
        if(Show.datesView === "buttons_by_calendar" || calenderbyCity || calenderbyFreeText) {
            hascalender = true;
        }
        if(!hascalender) {
            return;
        }

        Show.calanderWrap =   $('#calanderWrap');
        Show.selectedDate =  null;


        $(document).on('click','.back-to-calander',function(e){
            e.preventDefault();
            backToCalander();
        });

        createDatePicker();

        function backToCalander(){
            $('.cat-shows li').addClass('iscalanderCityhide');
            Show.calanderWrap.parent().removeClass('is-active');
            Show.calanderWrap.find('.inner-map-title h4').html("");
            Show.selectedDate = null;
        }

        function isDateHasShows(date) {
            var calenderbyCity = Show.datesView === "buttons_by_city_calendar";
            var calenderbyFreeText = Show.datesView === "buttons_by_freeText_calendar";

            var today = moment().startOf('day');
            if(today > moment(date).startOf('day')) {
                return false;
            }
            var d = moment(date).format('DD/MM/YYYY');

            var filterdShows = [];
            filterdShows = Show.events.filter(function(s) {
                return s.date === d;
            });
            if(calenderbyCity || calenderbyFreeText) {
                filterdShows = filterdShows.filter(function(s) {
                    return s.date === d && (calenderbyCity && Show.currentCat === s.city || calenderbyFreeText && Show.currentCat === s.freeText);
                });
            }
            if(filterdShows.length) {
                var soldout = filterdShows.filter(function(s) {
                    return !s.soldout;
                }).length === 0;

                var isLastTickets = false;
                if(Show.shows_last_tickets_in_dates && Show.shows_last_tickets_in_dates.length>0){
                    var filterdDates =   Show.shows_last_tickets_in_dates.filter(function(s) {
                        if(calenderbyCity || calenderbyFreeText) {
                            return s.date === d && (calenderbyCity && Show.currentCat === s.city || calenderbyFreeText && Show.currentCat === s.city);
                        }
                        return s.date === d
                    });
                    isLastTickets =  filterdDates.length > 0;
                }

                var isSomeChairs = false;
                if(Show.shows_some_chairs_in_dates && Show.shows_some_chairs_in_dates.length>0){
                    var filterdDates =   Show.shows_some_chairs_in_dates.filter(function(s) {
                        if(calenderbyCity || calenderbyFreeText) {
                            if(s.limit){
                                var limit =moment(s.date, "DD-MM-YYYY");
                                var curDate =  moment(d, "DD-MM-YYYY");
                                return curDate <= limit && (calenderbyCity && Show.currentCat === s.city || calenderbyFreeText && Show.currentCat === s.city);
                            }
                            return s.date === d && (calenderbyCity && Show.currentCat === s.city || calenderbyFreeText && Show.currentCat === s.city);
                        }
                        return s.date === d
                    });
                    isSomeChairs =  filterdDates.length > 0;
                }

                if(isSomeChairs){
                    soldout = false;
                }
                return {hasDate: true, soldout: soldout,isLastTickets:isLastTickets,isSomeChairs:isSomeChairs};
            }
            return false;

        }
        function toDate(d) {
            var date = new Date();
            var dateArr = d.split('/');
            date.setYear(dateArr[2]);
            date.setMonth(parseInt(dateArr[1]) - 1);
            date.setDate(dateArr[0]);
            return date;
        }
        function getShowsFromDate(date) {
            var iscalanderCity = Show.datesView === "buttons_by_city_calendar";
            var calenderbyFreeText = Show.datesView === "buttons_by_freeText_calendar";
            var shows = [];
            var dateStr = moment(date).format('DD/MM/YYYY');
            if(iscalanderCity || calenderbyFreeText) {
                var items =  $('.cat-shows li.iscalanderCityhide[data-date="' + dateStr + '"]');
                items.removeClass('iscalanderCityhide');
                Show.calanderWrap.find('.inner-map-title h4').html(items.first().find('.date').html());
                Show.calanderWrap.parent().addClass('is-active');
            }
            else {
                try {
                    const events = Show.events.filter((x)=>x.date === dateStr);
                    if(events.length === 1){
                        self.location.href = events[0].url;
                        return;
                    }
                } catch(e) {}

                handleCalendarSelectDate(dateStr);
            }
        }

        function handleCalendarSelectDate(dateStr) {
            $('#calendar').hide();
            $('.calendar-info').hide();
            $('.buttons_cats').show();
            $(`.buttons_cats a[data-cat='${dateStr}']`).click();
        }
        function getDateRange() {
            var min = 0;
            var max = 0;
            for(var i in Show.events) {
                var d = moment(Show.events[i].date, 'DD/MM/YYYY').format("x");
                min = min == 0 ? d : min > d ? d : min;
                max = max > d ? max : d;

            }

            var smallerDate = moment(min, 'x').format();
            var biggerDate = moment(max, 'x').format();
            var range = {min: smallerDate, max: biggerDate};
            return range;
        }
        function createDatePicker() {
            $('#calendar').datepicker({
                numberOfMonths : 1,
                disabled       : false,
                dateFormat     : 'dd/mm/yy',
                showOtherMonths: false,
                defaultDate    : new Date(),
                autoSize       : true,
                minDate        : new Date(getDateRange().min),
                maxDate        : new Date(getDateRange().max),
                prevText       : "<",
                nextText       : "<strong>יש כרטיסים נוספים</strong>",
                beforeShowDay  : function(date) {
                    var res = isDateHasShows(date);
                    if(res) {
                        return [true, "hasshow " +
                        (res.soldout ? 'soldout ' : ' ' +
                                (res.isLastTickets ? ' isLastTickets' : ' ') +
                                (res.isSomeChairs ? ' isSomeChairs' : ' ')
                        )];
                    }
                    else {
                        return [true, ' ui-datepicker-unselectable ui-state-disabled '];
                    }

                },
                onSelect       : function(date, inst) {
                    setTimeout(function() {
                        if($('.ui-datepicker-current-day').hasClass('hasshow')) {
                            var dateStr = $('#calendar').datepicker('getDate');
                            getShowsFromDate(dateStr);

                        }
                    }, 50);

                }


            });
        }
        function clearDateOPicker() {
            $('#calendar').datepicker('destroy');
        }
    };


        Show.getRelevantShows = function() {
            let filterBy = 'city';
            if(Show.datesView === 'buttons_by_hall'){
                filterBy = 'hall';
            }
            if(Show.datesView === 'buttons_by_freeText'){
                filterBy = 'freeText';
            }
            if(Show.datesView === 'buttons_by_date'){
                filterBy = 'date';
            }

            return Show.events.filter((x)=>x[filterBy] === Show.currentCat);

        }

    Show.validateTimerShow = function(btn) {
        var valid = true;
        if(!Array.isArray(Show['shows_btn_timers']) || Show['shows_btn_timers'].length == 0) {
            return valid;
        }
        Show['shows_btn_timers'].forEach(function(t) {
            if(t.url === String(btn.data('url'))) {
                var now = new Date();
                var timerDate = new Date(t.timer);
                valid = now > timerDate;
            }
        });
        return valid;
    };

    Show.initShowsTimers = function() {
        if(!Array.isArray(Show['shows_btn_timers']) || Show['shows_btn_timers'].length == 0) {
            return;
        }

        Show['shows_btn_timers'].forEach(function(t) {
            var button, groups, buttons;
            if(t.timer_linked_to === "show") {
                buttons = $('.order_show');
                button = buttons.filter(function() {
                    return $(this).attr('data-url') === t.url;
                });
            }
            if(t.timer_linked_to === "cat") {
                groups = $('ul.buttons_cats>li');
                button = groups.find(`[data-cat='${t.label}']`);
            }
            if(button && button.length > 0) {
                initButtonTimer(button, t);
            }

        });

        function initButtonTimer(button, timerObj) {
            var timerTemplate = $('<div class="show_btn_timer"><span class="title">המכירה תפתח בעוד</span><div class="clock"><div><span class="days"></span><div class="smalltext">ימים</div></div><div class="sep">:</div><div><span class="hours"></span><div class="smalltext">שעות</div></div><div class="sep">:</div><div><span class="minutes"></span><div class="smalltext">דקות</div></div><div class="sep">:</div><div><span class="seconds"></span><div class="smalltext">שניות</div></div></div></div>');
            button.append(timerTemplate);
            button.addClass('has_timer');
            button.parents('li').addClass('has_timer_inside');
            var deadline = new Date(timerObj.deadline);
            var now = new Date();
            var remain = formatU(deadline) - formatU(now)
            var endTime = formatU(now) + remain;


            updateButtonTimer(button, timerObj, endTime);
            timerObj.timeinterval = setInterval(function() {
                updateButtonTimer(button, timerObj, endTime);
            }, 1000);


            function remooveButtonTimer(button) {
                button.find('.show_btn_timer').fadeOut();
                button.removeClass('has_timer');
            };

            function updateButtonTimer(button, timerObj, endTime) {

                var t = getButtonTimerRemaining(endTime);

                if(t.total <= 0) {
                    clearInterval(timerObj.timeinterval);
                    remooveButtonTimer(button);
                }
                var clock = button.find('.show_btn_timer');
                var days = button.find('.days');
                var hours = button.find('.hours');
                var minutes = button.find('.minutes');
                var seconds = button.find('.seconds');

                days.text(t.days);
                hours.text(('0' + t.hours).slice(-2));
                minutes.text(('0' + t.minutes).slice(-2));
                seconds.text(('0' + t.seconds).slice(-2));

            }


        }

        function getButtonTimerRemaining(endTime) {
            var t = endTime - (new Date().getTime() / 1000);

            var seconds = Math.floor(t % 60);
            var minutes = Math.floor((t / 60) % 60);
            var hours = Math.floor((t / (60 * 60)) % 24);
            var days = Math.floor(t / (60 * 60 * 24));
            return {
                'total': t, 'days': days, 'hours': hours, 'minutes': minutes, 'seconds': seconds
            };
        }
    };

    Show.reloadActiveIframe = function() {
        $('#showIframe')[0].src = $('#showIframe')[0].src;

    };

    Show.contactPop = function() {
        var $pops = $('.contact-pop');
        var $btns = $('.contact-row button');
        if($btns.length > 0 && $pops.length > 0) {
            $pops.each(function(){
                var form = $(this).find('form');
                form.prepend($('<input type="hidden" name="show_name" />').val(Show.title), $('<input type="hidden" name="show_id" />').val(Show.id));
            });
            $btns.each(function(){
               $(this).click(function() {
                   var $pop = $('#' + $(this).attr('data-target'));
                    $.fancybox.open({
                        type     : 'html',
                        content  : $pop,
                        scrolling: 'auto',
                        topRatio : 0,
                        padding  : 0,
                        margin   : [42, 10, 10, 10],
                        helpers  : {
                            overlay: {
                                locked: false
                            }
                        }
                    });
                });
            });


        }
    };

    Show.openTermsPop = function() {
        return new Promise(function(resolve, reject) {
            if(!Show.terms_pop || typeof Show.terms_pop !== 'object') {
                resolve();
                return;
            }

            var res_cb = resolve;

            var input = $('<input type="checkbox">');
            var label = $('<label>').html([input, Show.terms_pop.label]);
            var form = $('<div >').html(label);
            var btn = $('<button class="backBtn">').text('אישור').click(function() {
                if(input.prop('checked')) {
                    $.fancybox.close();
                    res_cb();
                }
                else {
                    label.css('color', 'red');
                }
            });
            var h = $('<div class="h2" />').html(Show.terms_pop.title);
            var c = $('<div class="alert" />').html([h, Show.terms_pop.content, form, btn]);
            var contentHtml = $('<div class="inner" style="max-width: 100%"/>').html(c);
            $.fancybox.open({
                type     : 'html',
                content  : contentHtml,
                scrolling: 'auto',
                topRatio : 0,
                padding  : 0,
                margin   : [42, 10, 10, 10],
                maxWidth : 450,
                helpers  : {
                    overlay: {
                        locked: false
                    }
                },
                afterShow: function() {
                }
            });
        });


    };

    Show.hideTicketsTab = function() {
        var panels =  $('.tab-content');
        var btns   =  $('.tab-btn');
        if(device.mobile){
            btns =  $('.accordion-title');
        }
        if(device.mobile){
            $('#page-action-row').show();
            btns.show();
        }
        site.closeAllTabs(btns,panels);

    };

    Show.activateTicketsTab = function() {
        var panels =  $('.tab-content');
        var btns   =  $('.tab-btn');
        if(device.mobile){
            btns =  $('.accordion-title');
        }
        var  btn= $('#order');
        site.activateTab('tickets-tab',btn,btns,panels);

        if(device.mobile){
            //show only tickets
           // $('#page-action-row').hide();
          //  btns.hide();
        }
    };

        Show.activateContactTab = function() {
            var panels =  $('.tab-content');
            var btns   =  $('.tab-btn');
            if(device.mobile){
                btns =  $('.accordion-title');
            }
            var  btn= $('#order');
            site.activateTab('notify-tab',btn,btns,panels);

        };
    Show.showCover = function() {
        var cover = $('#page-cover');
        if(device.mobile){
            cover.find('.only-desktop').remove();
        }
        if(!device.mobile){
            cover.find('.only-mobile').remove();
        }
        const is_slider  = cover.find('img.slick-slide').length > 1;
        if(is_slider){
            set_css_variables('page-splash-height',`auto`);
        }
         cover.toggleClass('has-slider', is_slider).find('.slider').slick({
            rtl:true,
            adaptiveHeight: true
        });
    };

        Show.initMobileMenu  = function() {
            if(!device.mobile) {
                return
            }
           const bottomBorder = 10;
           const itemMinHeight =  ($(window).height() - $('.splash').outerHeight() - $('#app-header').outerHeight() - bottomBorder ) / 4;
            set_css_variables('tabs-mobile-button-height',`${itemMinHeight}px`);
        };
        Show.initFixedMenu  = function() {
            if(device.mobile) {
                return
            }
            var panels = $('.tab-content');
            var btns = $('.tab-btn');
            const cover = $('#page-cover');
            const boundry = cover.offset().top + cover.outerHeight();
            const actionRow = $('#page-action-row');
            const winHeight = $(window).outerHeight();
            const scrollLimit = winHeight - $(actionRow).outerHeight() - 5;

            $(window).on('scroll', function(e) {
                const top = $(e.delegateTarget).scrollTop();
                actionRow.toggleClass("fixed", top >= boundry);
            });

            if(typeof IntersectionObserver !== 'function'){
                return;
            }

            const options = {
                root: null,
                rootMargin: `0px 0px -${scrollLimit}px 0px`,
                threshold: 0,
            };
            const observer = new IntersectionObserver(observerCallback, options);

            panels.each(function() {
                const panel = $(this)[0];
                observer.observe(panel)
            });

            function observerCallback(entries, observer) {
                for (let entry of entries) {
                    if (entry.isIntersecting) {
                        const targetId= entry.target.id;
                        const navItem = $(`.tab-btn[aria-controls=${targetId}]`);

                        btns.removeClass('active');
                        navItem.addClass('active');
                    }
                }

            }

        };

    $(document).ready(function() {

        Show.loadPage();
        Show.initFixedMenu();
        Show.initMobileMenu();
        Show.esro();
        Show.ui();
        Show.displayFixes();
        Show.initCalendar();
        Show.initShowsTimers();
        Show.contactPop();
        Show.showCover();
        if(device.mobile && $('#mainNavBtn:visible').length > 0 && Show.autoOpenMobNav) {
            $('#mainNavBtn').click();
        }

        /*
        * TODO - ADD OPTION TO AUTO OPEN FIRST TAB
        * */
        if(!device.mobile){
          //  $('.tabs-menu button').first().click()
        }
    });

    $(window).resize(function() {
        Show.displayFixes();

    });


    /*countdown timer event*/
    $(document).on('timer_ended', function() {
        if(Show.hasOneShow) {
            Show.reloadActiveIframe()
        }

    })


})();

function formatU(d){
    return Math.round(d.getTime() / 1000)
}

